import {SelectTableFilter} from "@/components/selectTableFilter/SelectTableFilter.tsx";
import {Sorting, SortingDirection} from "@/components/table/Table.types.ts";

interface CloudStatusIncidentHistoryHeaderProps {
  sorting: Sorting;
  setSorting: (sorting: Sorting) => void;
}

export const CloudStatusIncidentHistoryHeader = ({sorting, setSorting}: CloudStatusIncidentHistoryHeaderProps) => (
  <div className="d-flex flex-row align-items-center justify-content-between mb-3">
    <div className="pulseTextH1Bold">Incident History</div>
    <SelectTableFilter
      enumOptions={{[SortingDirection.Asc]: "Oldest", [SortingDirection.Desc]: "Latest"}}
      value={sorting.direction}
      onChange={(direction) => setSorting({...sorting, direction: direction ?? SortingDirection.Desc})}
      placeholder="Sort by:"
      isSearchable={false}
      isClearable={false}
    />
  </div>
);
